module.exports = __webpack_public_path__ + "static/media/search.bbff377f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/search.svg
// module id = 1173
// module chunks = 0